import { BrandColors } from "./theme";

export const SemanticTokens = {
    primary: BrandColors.primary,
    colorScheme: {
        light: {
            surface: BrandColors.surface,
            formField: {
                background: '{surface.0}',
                borderColor: BrandColors.semantic.border,
                hoverBorderColor: BrandColors.primary[400],
                focusBorderColor: BrandColors.primary[500],
                invalidBorderColor: BrandColors.red[500],
                color: BrandColors.surface[700],
                placeholderColor: BrandColors.surface[400],
                disabledBackground: BrandColors.surface[100],
            },
            text: {
                color: BrandColors.semantic.text,
                hoverColor: BrandColors.surface[800],
                mutedColor: BrandColors.semantic.textSecondary,
                hoverMutedColor: BrandColors.surface[700],
            },
            content: {
                background: BrandColors.semantic.backgroundCard,
                hoverBackground: BrandColors.semantic.hover,
                borderColor: BrandColors.semantic.border,
                color: BrandColors.surface[700],
                hoverColor: BrandColors.surface[800],
            },
            highlight: {
                background: BrandColors.semantic.highlight,
                focusBackground: BrandColors.primary[100],
                color: BrandColors.semantic.highlightText,
                focusColor: BrandColors.primary[900],
            },
            mask: {
                background: BrandColors.semantic.mask,
            },
            navigation: {
                item: {
                    focusBackground: BrandColors.semantic.hover,
                    activeBackground: BrandColors.semantic.highlight,
                    color: BrandColors.surface[700],
                    focusColor: BrandColors.surface[800],
                    activeColor: BrandColors.primary[700],
                },
                submenuLabel: {
                    background: BrandColors.semantic.background,
                    color: BrandColors.surface[500],
                },
            },
        },
        dark: {
            surface: BrandColors.surface,
            formField: {
                background: '{surface.900}',
                borderColor: BrandColors.surface[700],
                hoverBorderColor: BrandColors.primary[400],
                focusBorderColor: BrandColors.primary[500],
                invalidBorderColor: BrandColors.red[400],
                color: BrandColors.surface[100],
                placeholderColor: BrandColors.surface[500],
                disabledBackground: BrandColors.surface[800],
            },
        },
    },
    transitionDuration: '0.2s',
    focusRing: {
        width: '2px',
        style: 'solid',
        color: BrandColors.semantic.focusRing,
        shadow: `0 0 0 3px ${BrandColors.primary[100]}`,
    },
};